module.exports = __webpack_public_path__ + "static/media/RecordsIcom0.dfb6f335.svg";